"use client"

import '../css/main.css'
import './style.css'
import Menu from '../common/menu.js';
import TopBar from "../common/topBar2";
import { useState ,useEffect,useRef} from 'react';
import { useData } from '../../contexts/DataContext';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';
import Loader from '../loaders/loader.jsx';
import { useLocation, useNavigate } from 'react-router-dom';
import LogoFile from '../Inputs/logo.jsx';
import React from 'react';
import { useMemo } from 'react';


export default function Settings() {
  const data = useData();
  const {user,selectedMicrocredit,userRole,setUser,userInfo} = useAuth(); 
  const [loading,setLoading]=useState(false)
  const {pathname} = useLocation()
  const [selectedPage,setSelectedPage]=useState('micro')
  const [settings,setSettings]=useState([])
  const [form,setForm]=useState({})

  const [currentPage,setCurrentPage]=useState(1)
  const [updateFilters,setUpdateFilters]=useState(null)
  const [search,setSearch]=useState('')
  const [filterOptions,setFilterOptions]=useState([])
  const [hideFilters,setHideFilters]=useState(true)
  let initial_filters={start_date:'',end_date:'',model_name:'',updated_by_id:'',action:''}
  const [filters,setFilters]=useState(initial_filters);

  const required_data=['settings','change_logs','microcredit_managers_and_operators']

  useEffect(()=>{ 
    if(!user || data.updateTable) return
    data.handleLoaded('remove',required_data)
    data._get(required_data,{
      microcredit_managers_and_operators:{microcredit_id:selectedMicrocredit},
      change_logs:{microcredit_id:selectedMicrocredit,search:search,page:currentPage,...filters,...data.getParamsFromFilters(filterOptions)},
    }) 
  },[user,pathname,search,currentPage,updateFilters])

  useEffect(() => { 
  if(!data.updateTable) return
  data.setUpdateTable(null)
  data.handleLoaded('remove',required_data)
  data._get(['change_logs',required_data],{
    microcredit_managers_and_operators:{microcredit_id:selectedMicrocredit},
    change_logs:{
      microcredit_id:selectedMicrocredit,
      search:search,
      page:1,
      ...filters,
      ...data.getParamsFromFilters(filterOptions)
    },
  }) 
}, [updateFilters]) // Adicione filters como dependência

  useEffect(()=>{
    data.handleLoaded('remove',required_data)
  },[updateFilters])

  useEffect(() => {
  setCurrentPage(1)
  setUpdateFilters(prev => !prev); 
  }, [filters]);


 
  let model_names={
    Contract: "Contrato",
    AccountDefinition: "Configuração de Conta",
    InventoryCategoryDefinition:'Categoria de inventário',
    InterestRateDefinition:'Taxa de juros',
    LatePaymentInterestDefinition:'Taxa de juros de mora',
    AccountCategoryDefinition:'Categoria de conta',
    Transation:'Transação de caixa',
    Client: "Cliente",
    Manager:'Gestor',
    ContractAsset: "Bem do Contrato",
    Installment: "Prestação",
    LatePaymentInterest: "Juros de Mora",
    PaymentHistory: "Histórico de Pagamento",
    Microcredit: "Microcrédito",
    User: "Usuário"
  }
  
  
  

  async function updateSettings(){ 

    toast.remove()
    toast.loading('A actualizar...') 
    setLoading(true)
   
    try{
       await data.makeRequest({method:'post',url:`api/settings/update`,withToken:true,data:{
            settings
       }, error: ``},0);
 
       toast.remove()
       toast.success("Actualizado com sucesso")
       setLoading(false)
 
    }catch(e){

       toast.remove()
       let msg="Acorreu um erro, tente novamente"
 
       setLoading(false)
 
       if(e.response){
         if(e.response.status==409){
           msg="Nome já existe"
         } 
         if(e.response.status==404){
             msg="Item não encontrado"
         }
         if(e.response.status==500){
             msg="Erro, inesperado. Contacte seu administrador"
         }
 
       }else if(e.code=='ERR_NETWORK'){
             msg="Verfique sua internet e tente novamente"
       }

       toast.error(msg)
    }
 }



 async function updateMicro(){ 
  toast.remove()
  toast.loading('A actualizar...') 

  setLoading(true)
 
  try{
     await data.makeRequest({method:'post',url:`api/microcredit/profile/update/${form.id}`,withToken:true,data:{
          ...form
     }, error: ``},0);

     toast.remove()
     toast.success("Actualizado com sucesso")
     setLoading(false)

     setUser({...user,microcredits:user.microcredits.map((i,_i)=>{
        if(i.id==selectedMicrocredit){
           return {...i,...form,logo_filename:form.logo_filename,name:form.name}
        }else{
           return i
        }
     })})

  }catch(e){
     toast.remove()

     let msg="Acorreu um erro, tente novamente"

     setLoading(false)

     if(e.response){
       if(e.response.status==409){
         msg="Nome já existe"
       } 
       if(e.response.status==404){
           msg="Item não encontrado"
       }
       if(e.response.status==500){
           msg="Erro, inesperado. Contacte seu administrador"
       }

     }else if(e.code=='ERR_NETWORK'){
           msg="Verfique sua internet e tente novamente"
     }

     toast.error(msg)

  }
}

 useEffect(()=>{
    setSettings(data._settings)
 },[data._settings])

 
 function handleUploadedFiles(upload){
   setForm({...form,[upload.key]:upload.filename})
 }


 useEffect(()=>{
  if(!user) return

  if(user?.role!="admin"){
      setForm(user.microcredits.filter(i=>i.id==selectedMicrocredit)[0] || {})
  }

  if(userRole=="manager"){
      setSelectedPage('micro')
  }else{
      setSelectedPage('nots')
  }

},[user,userRole])

 const pages=[
    {name:'Perfil da microcrédito',short_name:'Microcrédito',page:'micro'},
    /*{name:'Definições de caixa',short_name:'Caixa',page:'cash-managment'},
    {name:'Definições de contrato',short_name:'Contracto',page:'loans'},*/
    {name:'Controlo de operações',short_name:'Operações',page:'operations'},
    {name:'Notificações',short_name:'Notificações',page:'nots'},
 ]

 const HIDDEN_FIELDS = [
  // IDs e referências
  'id',
  'microcredit_id',
  'user_id',
  'created_by_id',
  'updated_by_id',
  'created_by_microuser_id',
  'reimbursement_performed_by_id',
  'disbursement_performed_by_id',
  'restructuring_to_id',
  'restructuring_from_id',
  'contract_id',
  'client_id',
  'account_id',
  'installment_id',
  'late_payment_interest_id',
  'contract_asset_id',
  'category_id',
  'expense_account_id',
  'RestructuringFrom',
  'contract_asset_contracts',
  'certificate_document_id',
  'google_docs_document_id',
  
  // Metadados
  'deleted',
  'createdAt',
  'updatedAt',
  'created_at',
  'updated_at',
  'permissions',
  'is_staff',

  'transition_performed_by_id',
  'reference_id',
  'payment_history_id',
  
  // Campos sensíveis ou irrelevantes
  'identity_ticket_src',
  'signed_contract_src',
  'declaration_of_residence_src',
  'declaration_of_residencia_src',
  
  // Adicione mais campos conforme necessário
  'contract_late_payment_interests'
];

 

const translations = {
  model_name: model_names,
  fields: {
    // Identificação básica
    id: "ID",
    name: "Nome",
    description: "Descrição",
    notes: "Notas",
    status: "Estado",
    client: 'Cliente',
    
    // Datas
    createdAt: "Criado em",
    updatedAt: "Atualizado em",
    created_at: "Criado em",
    deleted_at: 'Eliminado em',
    updated_at: "Atualizado em",
    date_of_birth: "Data de nascimento",
    passport_issue_date: "Data de emissão do passaporte",
    driver_license_issue_date: "Data de emissão da carta de condução",
    date_of_issuance_of_the_identity_card: "Data de emissão do BI",
    date_of_acquisition: "Data de aquisição",
    disbursement_date: "Data de desembolso",
    refund_date: "Data de reembolso",
    payday: "Data de pagamento",
    restructured_at: "Reestruturado em",
    
    // Localizações/emissão
    location: "Localização",
    place_of_issuance_of_the_identity_card: "Local de emissão do BI",
    passport_issue_location: "Local de emissão do passaporte",
    driver_license_issue_location: "Local de emissão da carta de condução",
    
    // Contatos
    email: "Email",
    primary_contact: "Contacto principal",
    secondary_contact: "Contacto secundário",
    address: "Endereço",
    neighborhood_name: "Bairro",
    avenue: "Avenida",
    block_number: "Número do quarteirão",
    house_number: "Número da casa",
    reason:"Razão",
    
    // Documentos
    identity_number: "Número de identificação",
    passport_number: "Número de passaporte",
    driver_license_number: "Número da carta de condução",
    registration_number: "Número de registo",
    type_of_identification_document: 'Tipo de documento de identificação',
    nuit: "NUIT",
    
    // Financeiro
    amount: "Montante",
    fees: "Taxas",
    left: "Valor em falta",
    paid: "Pago",
    taxes: "Impostos",
    insurance: "Seguro",
    total_to_pay: "Total a pagar",
    initial_amount: "Montante inicial",
    disbursement_value: "Valor de desembolso",
    restructuring_amount: "Montante de reestruturação",
    cost_of_preparation: "Custo de preparação",
    acquisition_amount: "Valor de aquisição",
    percentage: "Percentagem",
    duration_type: 'Tipo de duração',
    months: 'Meses',
    days: 'Dias',
    fees_percentage: "Percentagem de taxas",
    late_payment_interest: "Juros de mora",
    total_expenses: 'Total de despesas',
    Installment:'Prestação',
    Microcredit:'Microcrédito',

    payment_interval_value:"Intervalo de pagamento (em dias)",

    // Relacionamentos
    user_id: "ID do Usuário",
    microcredit_id: "ID do Microcrédito",
    client_id: "ID do Cliente",
    account_id: "ID da Conta",
    contract_id: "ID do Contrato",
    installment_id: "ID da Prestação",
    late_payment_interest_id: "ID do Juro de Mora",
    contract_asset_id: "ID do Bem do Contrato",
    category_id: "ID da Categoria",
    expense_account_id: "ID da Conta de Despesa",
    created_by_id: "Criado por (ID)",
    updated_by_id: "Atualizado por (ID)",
    created_by_microuser_id: "Criado por micro-usuário (ID)",
    reimbursement_performed_by_id: "Reembolsado por (ID)",
    disbursement_performed_by_id: "ID do Responsável pelo Desembolso",
    restructuring_to_id: "ID da Reestruturação Para",
    restructuring_from_id: "ID da Reestruturação De",
    
    // Status/configurações
    legal_status: "Estado legal",
    payment_status: "Estado do pagamento",
    approval_status: "Estado de aprovação",
    marital_status: "Estado civil",
    role: "Função",
    type: "Tipo",
    disbursement_performed_by: 'Responsável',
    interest_calculation_method: "Método de cálculo de juros",
    set_stamp_duty_manually: "Definir taxa de selo manualmente",
    set_insurance_fee_manually: "Definir taxa de seguro manualmente",
    set_preparation_fee_manually: "Definir taxa de preparação manualmente",
    
    // Listas/arrays
    installments: "Prestações",
    payment_histories: "Histórico de pagamentos",
    LatePaymentInterests: "Juros de mora",
    contract_assets: "Bens do contrato",
    media: "Mídia",
    model: "Modelo",
    
    // Outros
    quantity: "Quantidade",
    number_of_days: "Número de dias",
    number_of_installments: "Número de prestações",
    delay: "Atraso (dias)",
    to: "Até (dias)",
    from: "Desde (dias)",
    end: "Fim",
    start: "Início",
    deleted: "Eliminado",
    is_staff: "É funcionário",
    on_blacklist: "Na lista negra",
    permissions: "Permissões",
    job_title: "Cargo",
    father_name: "Nome do pai",
    mother_name: "Nome da mãe",
    
    // Relacionamentos aninhados
    "client.name": "Nome do cliente",
    "disbursement_performed_by.name": "Nome do responsável pelo desembolso",
    "contract_asset_contracts": "Associação de bens do contrato",
    "contract_asset_contracts.contract_asset_id": "ID do bem no contrato",
    "contract_late_payment_interests": "Associação de juros de mora",
    
    // Arquivos/documentos
    identity_ticket_src: "Fonte do bilhete de identidade",
    signed_contract_src: "Fonte do contrato assinado",
    declaration_of_residence_src: "Fonte da declaração de residência",
    declaration_of_residencia_src: "Fonte da declaração de residência",

    // Novos campos específicos dos logs
    accounts: "Contas",
    Account: "Conta",
    account: "Conta",
    Category: "Categoria",
    Contract: "Contrato",
    microuser: "Micro-usuário",
    reference: "Referência",
    reference_id: "ID da Referência",
    PaymentHistory: "Histórico de Pagamento",
    payment_history_id: "ID do Histórico de Pagamento",
    transition_performed_by: "Realizado por",
    transition_performed_by_id: "ID do Realizador da Transação",
    microcredit: "Microcrédito",
    category: "Categoria",
    contracts: "Contratos"
  },
  actions: {
    create: "Criado",
    update: "Atualizado",
    delete: "Eliminado"
  },
  values: {
    "null": "Nulo",
    "undefined": "Não definido",
    "[]": "Vazio",
    "{}": "Vazio",
    "true": "Sim",
    "false": "Não",
    "in": "Entrada",
    "out": "Saída"
  },
  status: {
    // Estados genéricos
    "active": "Ativo",
    "inactive": "Inativo",
    "pending": "Pendente",
    "paid":"Pago",
    "approved": "Aprovado",
    "rejected": "Rejeitado",
    "retained": "Retido",
    "delayed": "Atrasado",
    "legal": "Legal",
    "normal": "Normal",
    "confiscated": "Confiscado",
    
    // Estados civis
    "single": "Solteiro",
    "married": "Casado",
    "divorced": "Divorciado",
    "widowed": "Viúvo",

    "months": "Meses",
    "days": "Dias",
    "mobile-account":"Conta Móvel",
    "other": "Outro",
    "bank-account": "Conta Bancária",
    "mobile-account": "Conta Móvel",
    "in": "Entrada",
    "out": "Saída"
  },
  fieldValues: {
    "duration_type": {
      "days": "Dias",
      "months": "Meses"
    },
    "marital_status": {
      "single": "Solteiro",
      "married": "Casado",
      "divorced": "Divorciado",
      "widowed": "Viúvo"
    },
    "legal_status": {
      "normal": "Normal",
      "legal": "Legal"
    },
    "payment_status": {
      "pending": "Pendente",
      "paid": "Pago",
      "delayed": "Atrasado"
    },
    "approval_status": {
      "approved": "Aprovado",
      "pending": "Pendente",
      "rejected": "Rejeitado"
    },
    "interest_calculation_method": {
      "price": "Price",
      "simple": "Simples"
    },
    "type": {
      "other": "Outro",
      "bank-account": "Conta Bancária",
      "mobile-account": "Conta Móvel",
      "in": "Entrada",
      "out": "Saída"
    },
    "role": {
      "client": "Cliente",
      "admin": "Administrador",
      "manager": "Gestor",
      "normal": "Normal"
    },
    "status": {
      "retained": "Retido",
      "confiscated": "Confiscado",
      "active": "Ativo",
      "inactive": "Inativo"
    }
  }
};


const getModelRoute = (modelName, id) => {
  const routes = {
    Contract: `/loan/${id}`,
    Client: `/clients/${id}`,
    User: `/users/${id}`,
    // Adicione mais mapeamentos conforme necessário
  };
  return routes[modelName] || null;
};

// Função para formatar valores complexos

function formatValue(value) {
  if (value === null) return translations.values["null"];
  if (value === undefined) return translations.values["undefined"];
  if (Array.isArray(value) && value.length === 0) return translations.values["[]"];
  if (typeof value === 'object' && Object.keys(value).length === 0) return translations.values["{}"];
  
  // Verifica se é uma data ISO válida
  if (typeof value === 'string' && isValidISODate(value)) {
    return formatISODate(value);
  }
  
  return value;
}

/**
 * Verifica se a string é uma data ISO válida (com ou sem hora)
 */
function isValidISODate(dateString) {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/; // Apenas data (YYYY-MM-DD)
  const isoDateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?(Z|[+-]\d{2}:\d{2})?$/; // Data + hora
  
  return isoDateRegex.test(dateString) || isoDateTimeRegex.test(dateString);
}

/**
 * Formata uma data ISO em PT (apenas data ou data + hora)
 */
function formatISODate(isoString) {
  const date = new Date(isoString);
  
  // Se a string original tem apenas data (YYYY-MM-DD)
  if (/^\d{4}-\d{2}-\d{2}$/.test(isoString)) {
    return date.toLocaleDateString('pt-PT'); // Formato: DD/MM/YYYY
  }
  // Se tem data e hora
  else {
    return date.toLocaleString('pt-PT'); // Formato: DD/MM/YYYY, HH:MM:SS
  }
}
// Função para traduzir valores específicos
function translateSpecificValue(field, value) {
  // Verifica se o campo tem valores específicos para traduzir
  if (translations.fieldValues[field]) {
    return translations.fieldValues[field][value] || 'value';
  }
  
  // Verifica se é um status
  if (translations.status[value]) {
    return translations.status[value];
  }
  
  // Verifica se é um valor simples com tradução
  if (translations.values[value]) {
    return translations.values[value];
  }
  
  return value;
}

// Função para formatar objetos/arrays complexos
function formatComplexValue(value, indent = 0, parentField = '') {
  if (Array.isArray(value)) {
    if (value.length === 0) return translations.values["[]"];
    
    return (
      <div className="ml-4">
        {value.map((item, i) => (
          <div key={i} className="mt-1">
            <span className="font-semibold">({i + 1})</span>
            {' '}
            {typeof item === 'object' ? 
              formatComplexValue(item, indent + 1, parentField) : 
              translateSpecificValue(parentField, formatValue(item))}
          </div>
        ))}
      </div>
    );
  }
  
  if (typeof value === 'object' && value !== null) {
    if (Object.keys(value).length === 0) return translations.values["{}"];
    
    return (
      <div className={`ml-${indent * 4}`}>
        {Object.entries(value).map(([key, val]) => {
          const fullFieldPath = parentField ? `${parentField}.${key}` : key;
          return (
            <div key={key} className="mt-1">
              <span className="font-semibold">{translateField(key)}:</span> 
              {' '}
              {typeof val === 'object' ? 
                formatComplexValue(val, indent + 1, fullFieldPath) : 
                translateSpecificValue(fullFieldPath, formatValue(val))}
            </div>
          );
        })}
      </div>
    );
  }
  
  return translateSpecificValue(parentField, formatValue(value));
}

 // Adicione isso no início do seu componente


// Função para traduzir nomes de campos, ocultando os que estão em HIDDEN_FIELDS
function translateField(fieldPath) {
  // Verifica se o campo ou qualquer parte aninhada está na lista de ocultos
  const parts = fieldPath.split('.');
  
  // Verifica cada parte do caminho (incluindo índices de array)
  for (let part of parts) {
    const arrayIndexMatch = part.match(/(.*)\[(\d+)\]/);
    const fieldName = arrayIndexMatch ? arrayIndexMatch[1] : part;
    
    if (HIDDEN_FIELDS.includes(fieldName)) {
      return null; // Retorna null para campos que devem ser ocultos
    }
  }

  let translatedParts = [];
  
  for (let part of parts) {
    const arrayIndexMatch = part.match(/(.*)\[(\d+)\]/);
    
    if (arrayIndexMatch) {
      const fieldName = arrayIndexMatch[1];
      const arrayIndex = parseInt(arrayIndexMatch[2]) + 1;
      const translatedField = translations.fields[fieldName] || fieldName;
      translatedParts.push(`(${arrayIndex}) ${translatedField}`);
    } else {
      translatedParts.push(translations.fields[part] || part);
    }
  }
  
  return translatedParts.join(' > ');
}




// Componente separado para cada item de log


// Adicione estas constantes no início do arquivo
const ACTION_COLORS = {
  create: 'text-green-600',
  update: 'text-blue-600',
  delete: 'text-red-600'
};

const ACTION_ICONS = {
  create: '➕',
  update: '✏️',
  delete: '🗑️'
};

// Componente LogItem atualizado

// Componente LogItem atualizado

function LogItem({ log }) {
  const [expanded, setExpanded] = useState(false);
  const [expandedChanges, setExpandedChanges] = useState({});
  const [expandedPreviousState, setExpandedPreviousState] = useState(false);
  const navigate = useNavigate();

  console.log(Math.random())

  // Filtra as alterações para remover campos ocultos
  const visibleChanges = useMemo(() => {
  return log.changes.filter(change => 
    translateField(change.field) !== null
  );
}, [log.changes]);

  // Abre todos os dropdowns quando o log é expandido
  useEffect(() => {
  if (expanded) {
    const allExpanded = {};
    visibleChanges.forEach((_, index) => {
      allExpanded[index] = true;
    });
    setExpandedChanges(allExpanded);
    
    if (['delete', 'create'].includes(log.action)) {
      setExpandedPreviousState(true);
    }
  }
  // Remova a else parte para evitar reset desnecessário
}, [expanded, log.action]); // Remova visibleChanges da dependência

  const toggleChange = (index) => {
    setExpandedChanges(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };


  const handleViewItem = (e) => {
    e.stopPropagation();
    const route = getModelRoute(log.model_name, log.record_id);
    navigate(route);
  };

  // Se não houver alterações visíveis e não for delete/create, não renderiza o item
  if (visibleChanges.length === 0 && !['delete', 'create'].includes(log.action)) {
    return null;
  }

  return (
    <div className="border rounded-lg overflow-hidden mb-3">
      <div 
        className="p-4 bg-gray-50 hover:bg-gray-100 cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="mr-2">{ACTION_ICONS[log.action] || '📝'}</span>
            <div>
              <span className="font-medium">
                {translations.model_name[log.model_name] || log.model_name}
              </span>
              <span className="ml-1">•</span>
              <span className={`ml-1 font-semibold ${ACTION_COLORS[log.action] || 'text-gray-600'}`}>
                {translations.actions[log.action] || log.action}
              </span>
            </div>
          </div>
          <div className="flex items-center">
            {(log.action !== 'delete' && log.model_name=="Contract")  && (
              <button 
                onClick={handleViewItem}
                className="ml-2 px-3 py-1 bg-blue-100 text-blue-600 rounded-md text-sm hover:bg-blue-200 flex items-center"
              >
                <EyeIcon className="w-4 h-4 mr-1" />
                Ver
              </button>
            )}
            <ChevronIcon expanded={expanded} className="ml-3" />
          </div>
        </div>
        
        <div className="text-sm text-gray-500 mt-1">
          {new Date(log.updated_at).toLocaleString('pt-PT')} • ID: {log.record_id}
        </div>
        {log.updater && (
          <div className="text-xs text-gray-400 mt-1">
            Alterado por: <span className="font-medium">{log.updater.name}</span> {/** (ID: {log.updater.id}) **/}
          </div>
        )}
      </div>
      
      {expanded && (
        <div className="p-4 border-t bg-gray-50">
          {/* Seção para previous_state em ações de delete/create */}
          {['delete', 'create'].includes(log.action) && log.previous_state && (
            <div className="mb-4 border rounded-md overflow-hidden bg-white">
              <div 
                className="p-3 hover:bg-gray-50 cursor-pointer flex justify-between items-center"
                onClick={() => setExpandedPreviousState(!expandedPreviousState)}
              >
                <span className="font-medium">
                  {log.action === 'delete' ? 'Estado antes da eliminação' : 'Estado inicial'}
                </span>
                <div className="flex items-center">
                  <span className={`text-xs mr-2 ${expandedPreviousState ? 'text-gray-500' : 'text-gray-400'}`}>
                    {expandedPreviousState ? 'Ocultar detalhes' : 'Mostrar detalhes'}
                  </span>
                  <ChevronIcon expanded={expandedPreviousState} small />
                </div>
              </div>
              
              {expandedPreviousState && (
                <div className="p-3 border-t">
                  <div className="bg-yellow-50 p-3 rounded-md">
                    <div className="font-semibold text-yellow-700 flex items-center">
                      <ArchiveIcon className="w-4 h-4 mr-1" />
                      {log.action === 'delete' ? 'Dados eliminados' : 'Dados iniciais'}
                    </div>
                    <div className="mt-2 text-sm">
                      <CompactValue 
                        value={log.previous_state} 
                        field={log.model_name.toLowerCase()}
                        isFullObject={true}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Seção para alterações normais */}
          <div className="space-y-3">
            {visibleChanges.map((change, i) => (
              <div key={i} className="border rounded-md overflow-hidden bg-white">
                <div 
                  className="p-3 hover:bg-gray-50 cursor-pointer flex justify-between items-center"
                  onClick={() => toggleChange(i)}
                >
                  <span className="font-medium">{translateField(change.field)}</span>
                  <div className="flex items-center">
                    <span className={`text-xs mr-2 ${expandedChanges[i] ? 'text-gray-500' : 'text-gray-400'}`}>
                      {expandedChanges[i] ? 'Ocultar detalhes' : 'Mostrar detalhes'}
                    </span>
                    <ChevronIcon expanded={expandedChanges[i]} small />
                  </div>
                </div>
                
                {expandedChanges[i] && (
                  <div className="p-3 grid grid-cols-1 md:grid-cols-2 gap-3 border-t">
                    <div className="bg-red-50 p-3 rounded-md">
                      <div className="mt-1 text-sm  flex items-center">
                        <ArrowDownIcon className="w-4 h-4 mr-1" />
                        <CompactValue value={change.from} field={change.field} />
                      </div>
                    </div>
                    <div className="bg-green-50 p-3 rounded-md">
                      <div className="mt-1 text-sm flex items-center">
                       <ArrowUpIcon className="w-4 h-4 mr-1" /> <CompactValue value={change.to} field={change.field} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}


// Adicione estes novos ícones
function EyeIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  );
}

function ArrowUpIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
    </svg>
  );
}

function ArrowDownIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
    </svg>
  );
}



function CompactValue({ value, field, isFullObject = false }) {
  const [expanded, setExpanded] = useState(false);

  // Verifica se o campo ou qualquer parte aninhada está na lista de ocultos
  const checkHiddenField = (fieldPath) => {
    const parts = fieldPath.split('.');
    return parts.some(part => {
      const arrayIndexMatch = part.match(/(.*)\[(\d+)\]/);
      const fieldName = arrayIndexMatch ? arrayIndexMatch[1] : part;
      return HIDDEN_FIELDS.includes(fieldName);
    });
  };

  if (checkHiddenField(field)) {
    return null;
  }

  if (value === null || value === undefined) {
    return <span className="text-gray-500">{translations.values[String(value)] || String(value)}</span>;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return <span className="text-gray-500">{translations.values["[]"]}</span>;
    }
    
    return (
      <div>
        <button 
          onClick={() => setExpanded(!expanded)}
          className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
        >
          {expanded ? (
            <>
              <MinusIcon small /> Ocultar itens ({value.length})
            </>
          ) : (
            <>
              <PlusIcon small /> Mostrar itens ({value.length})
            </>
          )}
        </button>
        
        {expanded && (
          <div className="mt-2 ml-4 space-y-2">
            {value.map((item, i) => {
              const itemField = `${field}[${i}]`;
              if (checkHiddenField(itemField)) {
                return null;
              }
              return (
                <div key={i} className="border-l-2 border-gray-200 pl-2">
                  <div className="font-medium">({i + 1})</div>
                  <CompactValue value={item} field={itemField} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  if (typeof value === 'object') {
    return (
      <div>
        <button 
          onClick={() => setExpanded(!expanded)}
          className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
        >
          {expanded ? (
            <>
              <MinusIcon small /> {isFullObject ? 'Ocultar dados completos' : 'Ocultar detalhes'}
            </>
          ) : (
            <>
              <PlusIcon small /> {isFullObject ? 'Mostrar dados completos' : 'Mostrar detalhes'}
            </>
          )}
        </button>
        
        {expanded && (
          <div className="mt-2 ml-4 space-y-2">
            {Object.entries(value).map(([key, val]) => {
              const itemField = `${field}.${key}`;
              if (checkHiddenField(itemField)) {
                return null;
              }
              return (
                <div key={key} className="flex flex-wrap">
                  <div className="font-medium mr-2">{translateField(key)}:</div>
                  <CompactValue value={val} field={itemField} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  return <span>{translateSpecificValue(field, formatValue(value))}</span>;
}

// Novo ícone ArchiveIcon
function ArchiveIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
    </svg>
  );
}

// Componentes de ícones
function ChevronIcon({ expanded, small = false }) {
  return (
    <svg
      className={`${small ? 'w-4 h-4' : 'w-5 h-5'} text-gray-500 transition-transform duration-200 ${expanded ? 'transform rotate-180' : ''}`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  );
}

function PlusIcon({ small = false }) {
  return (
    <svg
      className={`${small ? 'w-3 h-3 mr-1' : 'w-4 h-4 mr-1'} text-blue-600`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
    </svg>
  );
}

function MinusIcon({ small = false }) {
  return (
    <svg
      className={`${small ? 'w-3 h-3 mr-1' : 'w-4 h-4 mr-1'} text-blue-600`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
    </svg>
  );
}

const MemoizedLogItem = React.memo(LogItem);


  return (
    <>
    <main className="dashboard-container">

        <div className="dashboard">

            <Menu/>

            <div className="main-dashboard">
               
            <TopBar activePage={'Configurações'}/>

                  <div className="center mb-10">
                    {(data._loaded.includes('settings') && !loading) && <div className={`inline-flex ${userRole!="manager" ? 'hidden':''} bg-white overflow-hidden rounded-[0.3rem] mb-10 shadow justify-between gap-x-3 px-2`}>
                         {pages.map((i,_i)=>(
                          <span  onClick={()=>setSelectedPage(i.page)} className={`py-2 text-[15px] relative cursor-pointer flex ${selectedPage==i.page ? '':'opacity-50'}`}>
                               <label className="cursor-pointer max-md:hidden">{i.name}</label>
                               <label className="cursor-pointer md:hidden">{i.short_name}</label>
                               {selectedPage==i.page && <label className="w-full absolute bottom-0 flex h-[3px] bg-custom_blue-300 rounde-t-[0.3rem]"></label>}
                          </span>
                         ))}
                    </div>}

                    {(!data._loaded.includes('settings') || loading) && <div className="w-full flex justify-center items-center h-[200px]">
                            <Loader/><span>A carregar...</span>
                    </div>}



                    {(selectedPage=="micro")} 


                    {(data._loaded.includes('settings') && !loading && selectedPage=="micro") && <div className="w-full bg-white rounded-[0.4rem] px-3 py-2 pb-5">
                      
                      <div className="mb-10 w-full">
                        <LogoFile res={handleUploadedFiles} _upload={{key:'logo_filename',filename:form.logo_filename}} label={'Logotipo'}/>
                      </div>

                      <div class="max-w-sm">
                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Nome da empresa</label>
                          <input value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5"  required />
                        </div>
                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Localização</label>
                          <input value={form.location} onChange={(e)=>setForm({...form,location:e.target.value})} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5"  required />
                        </div>

                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Província</label>
                          <input value={form.province} onChange={(e)=>setForm({...form,province:e.target.value})} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5"  required />
                        </div>

                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Gestor da empresa</label>
                          <input value={form.company_manager} onChange={(e)=>setForm({...form,company_manager:e.target.value})} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5"  required />
                        </div>

                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Inicio das actividades</label>
                          <input type="date" value={form.start_of_activities} onChange={(e)=>setForm({...form,start_of_activities:e.target.value})} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5"  required />
                        </div>
                        
                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Email</label>
                          <input value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5"  required />
                        </div>
                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Contacto</label>
                          <input value={form.primary_contact} onChange={(e)=>setForm({...form,primary_contact:e.target.value})} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5"  required />
                        </div>
                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Contacto alternativo</label>
                          <input value={form.secondary_contact} onChange={(e)=>setForm({...form,secondary_contact:e.target.value})} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5"  required />
                        </div>       
                        
                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Nuit</label>
                          <input onWheel={(e) => e.target.blur()} value={form.nuit} onChange={(e)=>setForm({...form,nuit:e.target.value})} type="number" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5" required />
                        </div>

                        <div class="mb-5">
                          <label class="block mb-2 text-sm font-medium text-gray-900">Link de website</label>
                          <input value={form.website_link} onChange={(e)=>setForm({...form,website_link:e.target.value})} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5"  required />
                        </div>
                        <div class="mb-5">
                           <label for="message" class="block mb-2 text-sm font-medium text-gray-900">Descrição</label>
                           <textarea value={form.description} onChange={(e)=>setForm({...form,description:e.target.value})} id="message" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300"></textarea>
                         </div>
                         
                        <button onClick={()=>{
                             updateMicro()
                         }} id="confirm-button" type="button" class="py-2 px-4 w-full text-sm font-medium text-center rounded-[0.3rem] text-white bg-custom_blue-400 sm:w-auto bg-honolulu_blue-500 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300">Actualizar empresa</button>
                                                       
                      </div>
                    </div>}
                     
                    {(data._loaded.includes('settings') && !loading && selectedPage=="nots") && <div  className={`settings ${loading ? 'loading' :''}`}>                         
                         <div className="settings-options">
                                                     <div className="set option-c">
                                                              <div className="top-title">Preferências de Usuário</div>
                                                              <div className="option pop-ups">
                                                                       <div className="title">Receber Notificações por email</div>
                                                                       <div className={` ${loading.email_notifications ? 'loading' :''}`}>
                                                                             <div onClick={()=>{
                                                                                  setSettings([...settings.filter(i=>i.key!="email_notifications"),{
                                                                                      ...settings.filter(i=>i.key=="email_notifications")[0],
                                                                                      value:settings.filter(i=>i.key=="email_notifications")[0].value=="true" ? "false" : "true"
                                                                                  }])
                                                                             }} className={`switch ${settings.filter(i=>i.key=="email_notifications")[0]?.value=="true" ? 'active' :''}`}></div>
                                                                       </div>
                                                              </div>
                    
                                                              {/**user.microcredits?.filter(i=>i.id==selectedMicrocredit)[0]?.plan!="gold" && <div className="option pop-ups">
                                                                        <div className="title">Receber Notificações por SMS</div>
                                                                        <div className={` ${loading.sms_notifications ? 'loading' :''}`}>
                                                                              <div onClick={()=>{
                                                                                setSettings([...settings.filter(i=>i.key!="sms_notifications"),{
                                                                                  ...settings.filter(i=>i.key=="sms_notifications")[0],
                                                                                  value:settings.filter(i=>i.key=="sms_notifications")[0].value=="true" ? "false" : "true"
                                                                                 }])
                                                                                }} className={`switch ${settings.filter(i=>i.key=="sms_notifications")[0]?.value=="true" ? 'active' :''}`}></div>
                                                                        </div>
                                                              </div> */}
                                                            
                                                        </div>
                                                        <div className="py-3">
                                                          <button id="confirm-button" type="button" class="py-2 hidden px-4 w-full text-sm font-medium text-center rounded-[0.3rem] text-gray-500 border sm:w-auto bg-honolulu_blue-500 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300">Cancelar</button>
                                                          <button onClick={()=>{
                                                             updateSettings()
                                                          }} id="confirm-button" type="button" class="ml-2 py-2 px-4 w-full text-sm font-medium text-center rounded-[0.3rem] text-white bg-custom_blue-400 sm:w-auto bg-honolulu_blue-500 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300">Actualizar notificações</button>
                                                       
                                                        </div>
          
                                                  </div>
                       </div>}


                       
 

 {(!loading && selectedPage === "operations" && data._loaded.includes('settings')) && (
 
   <div className="w-full bg-white rounded-lg shadow p-6">
    <h2 className="text-2xl font-bold text-gray-800 mb-6">Registo de Operações</h2>
    
    {/* Cards de Estatísticas */}
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      {/* Card Total */}
      <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
        <div className="text-gray-500 text-sm font-medium">Total de Operações</div>
        <div className="text-2xl font-bold text-gray-800 mt-1">
          {data._change_logs?.total || 0}
        </div>
      </div>
      
      {/* Card Criações */}
      <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
        <div className="text-gray-500 text-sm font-medium">Criações</div>
        <div className="text-2xl font-bold text-green-600 mt-1">
          {data._change_logs?.stats?.actions?.create || 0}
        </div>
      </div>
      
      {/* Card Atualizações */}
      <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
        <div className="text-gray-500 text-sm font-medium">Atualizações</div>
        <div className="text-2xl font-bold text-blue-600 mt-1">
          {data._change_logs?.stats?.actions?.update || 0}
        </div>
      </div>
      
      {/* Card Eliminações */}
      <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
        <div className="text-gray-500 text-sm font-medium">Eliminações</div>
        <div className="text-2xl font-bold text-red-600 mt-1">
          {data._change_logs?.stats?.actions?.delete || 0}
        </div>
      </div>
    </div>
    
 


     <div className={`extra-filters ${hideFilters ? '_hide':''}`}>
                    <label onClick={()=>setHideFilters(!hideFilters)} className="underline sm:hidden text-[15px]  text-custom_blue-400 absolute top-4 cursor-pointer">{hideFilters ? 'Mostrar filtros':'Esconder filtros'}</label>

                    <div className="input-container">

                         <div className="inputs">
                              <span>Data de inicio</span>
                              <input type="date" value={filters.start_date} onChange={(e)=>setFilters({...filters,start_date:e.target.value})} />
                         </div>

                         <div className="inputs">
                              <span>Data de fim</span>
                              <input type="date" value={filters.end_date} onChange={(e)=>setFilters({...filters,end_date:e.target.value})} />
                         </div>

                          <div className="inputs">
                              <span>Tipo de operação</span>
                              <select  value={filters.action} onChange={e=>setFilters({...filters, action:e.target.value})}>
                                   <option selected value="">Selecionar operação</option>
                                   {[
                                        {label:'Criar',name:'create'},
                                        {label:'Actualizar',name:'update'},
                                        {label:'Eliminar',name:'delete'}
                                   ].map(i=>(
                                        <option key={i.name} selected={filters.action == i.name} value={i.name}>{i.label}</option>
                                   ))}
                              </select>
                         </div>
                         
                         <div className="inputs">
                              <span>Módulo</span>
                              <select  value={filters.model_name} onChange={e=>setFilters({...filters, model_name:e.target.value})}>
                                   <option selected value="">Selecionar</option>
                                   {Object.keys(model_names).map(k=>(
                                        <option key={k} selected={filters.model_name === k} value={k}>{model_names[k]}</option>
                                   ))}
                              </select>
                         </div>
                       

                         <div className="inputs">
                              <span>Responsável</span>
                              <select onChange={e=>setFilters({...filters, updated_by_id:e.target.value})} value={filters.updated_by_id}>
                                   <option disabled selected value="">Selecione uma opção</option>
                                   {data._microcredit_managers_and_operators.map((i,_i)=>(
                                        <option value={i.id} key={'_user-'+_i}>{i.name}</option>
                                   ))}
                              </select> 
                         </div>

                         
                         
                    </div>
                     <div className="options">
                          <span onClick={()=>setFilters(initial_filters)}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path fill="#fff" d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z"/></svg> </span>
                    </div>

                  

    </div>
    
    
    {!data._loaded.includes('change_logs') ? (
  <div className="flex justify-center items-center h-40">
    <Loader />
    <span className="ml-2">A carregar registos...</span>
  </div>
) : (
  <div className="space-y-4">
    {data._change_logs?.data?.length > 0 ? (
      data._change_logs.data.map((log, index) => (
        <MemoizedLogItem key={index} log={log} />
      ))
    ) : (
      <div className="flex flex-col items-center justify-center py-10">
        <h3 className="text-lg font-medium text-gray-700 mb-1">Nenhum registo encontrado</h3>
        <p className="text-gray-500 text-center max-w-md">
          {search && (
            <span className="block mt-2">
              Tentou pesquisar por: <span className="font-semibold">"{search}"</span>
            </span>
          )}
        </p>
        {Object.values(filters).some(Boolean) && (
          <button
            onClick={() => {
              setFilters(initial_filters);
              setSearch('');
            }}
            className="mt-4 px-4 py-2 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors"
          >
            Limpar filtros
          </button>
        )}
      </div>
    )}
    
    {/* Paginação - mantido do código original */}
    {data._change_logs?.totalPages > 1 && data._change_logs?.data?.length > 0 && (
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded-md ${currentPage === 1 ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
        >
          Anterior
        </button>
        
        <span className="text-sm text-gray-700">
          Página {currentPage} de {data._change_logs.totalPages}
        </span>
        
        <button
          onClick={() => setCurrentPage(p => Math.min(data._change_logs.totalPages, p + 1))}
          disabled={currentPage === data._change_logs.totalPages}
          className={`px-4 py-2 rounded-md ${currentPage === data._change_logs.totalPages ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
        >
          Próxima
        </button>
      </div>
    )}
  </div>
)}


  </div>
)}

 

                  </div>

                  
            </div>
        </div>
    </main>
    </>
  );
}
